import { render, staticRenderFns } from "./revision.vue?vue&type=template&id=446e3091&"
import script from "./revision.vue?vue&type=script&lang=js&"
export * from "./revision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports